/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import * as microsoftTeams from "@microsoft/teams-js";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

// Detect if running in Teams
const isInTeams = () => {
  try {
    return window.parent !== window.self;
  } catch {
    return false;
  }
};

// Get the correct redirect URI based on environment
const getRedirectUri = () => {
  if (isInTeams()) {
    return window.location.origin + "/auth-end.html";
  }
  // For web app, use the fixed production URL
  return "https://landdocumentuat.azimpremjifoundation.org";
    // return "http://localhost:3000";
};
// return https://landdocumentuat.azimpremjifoundation.org
export const msalConfig = {
  auth: {
    clientId: "39252527-49c6-4952-93a6-0869ead1810f",
    authority: "https://login.microsoftonline.com/349aae38-7afe-452a-b57e-45cebd0c7a50",
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: window.location.origin + "/",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: isInTeams(),
    secureCookies: true
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false
    },
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    asyncPopups: false
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read", "User.ReadBasic.All"],
  prompt: "select_account"
};

/**
 * Teams-specific login request for SSO
 */
export const teamsLoginRequest = {
  scopes: ["User.Read", "User.ReadBasic.All"],
  prompt: "none"
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphUsersEndpoint: "https://graph.microsoft.com/v1.0/users"
};
